import axios from 'axios';

// const HistoryService = {
//   get: async function(tag) {
//     try {
//       const response = await ApiService.get(`/api/history/${tag}`);
//       return response.data;
//     } catch (error) {
//       throw error;
//     }
//   },
// };
const HistoryService = {
  get: async function (tag) {
    try {
      const response = await axios.get(`/api/history/${tag}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default HistoryService;

export { HistoryService };

